import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { TURNKEY_STEPS } from "@/data/content";

export const Turnkey = () => (
    <section id="turnkey" data-testid="turnkey-section" className="relative overflow-hidden bg-omsivo-paper py-24 lg:py-32">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="turnkey-heading"
                align="center"
                overline="Turnkey Project Solutions"
                title={<>One journey. <span className="text-flame-dark">One construction partner.</span></>}
                description="OMSIVO turnkey delivery carries your project through every phase — you deal with one team, one scope and one standard of accountability."
            />
            <div className="mt-16 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8" data-testid="turnkey-workflow">
                {TURNKEY_STEPS.map((s, i) => (
                    <Reveal key={s} delay={0.06 * i}>
                        <div className="group relative flex h-full flex-col items-center rounded-2xl border border-omsivo-navy/10 bg-white px-3 py-6 text-center transition-colors hover:border-flame/60">
                            <span className="font-mono text-[10px] text-flame-dark">{String(i + 1).padStart(2, "0")}</span>
                            <span className="mt-2 font-display text-[13px] font-extrabold uppercase tracking-[0.1em] text-omsivo-navy">{s}</span>
                            {i < TURNKEY_STEPS.length - 1 && (
                                <ArrowRight className="absolute -right-3 top-1/2 z-10 hidden h-4 w-4 -translate-y-1/2 text-flame lg:block" />
                            )}
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
